var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#EB2019"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2798 46.0917C21.6331 39.1309 24.606 32.8258 29.5369 28.82C31.459 27.2572 34.3331 28.5954 34.3331 31.0654C34.3331 31.9725 33.902 32.8078 33.2014 33.3737C29.7076 36.2209 27.6059 40.7117 28.1178 45.6695C28.7825 52.1273 33.9559 57.3547 40.4047 58.0732C48.8205 59.0163 55.9699 52.4237 55.9699 44.1966C55.9699 39.8315 53.949 35.9245 50.7965 33.3647C50.0959 32.7988 49.6738 31.9636 49.6738 31.0654C49.6738 28.6224 52.503 27.2392 54.4071 28.7661C58.9159 32.4037 61.808 37.9633 61.808 44.1966C61.808 55.5943 52.1258 64.7825 40.5484 63.9472C30.974 63.2736 23.169 55.6481 22.2798 46.0917ZM41.9945 20C40.3778 20 39.0754 21.3113 39.0754 22.919V36.3646C39.0754 37.9813 40.3868 39.2836 41.9945 39.2836C43.6022 39.2836 44.9135 37.9723 44.9135 36.3646V22.919C44.9135 21.3113 43.6112 20 41.9945 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPower);
export default __webpack_public_path__ + "static/media/icon-power.c960897ee5e151e326a3dbd268938ccd.svg";
export { ForwardRef as ReactComponent };